import {Component, Inject, OnDestroy, Input} from '@angular/core';
import {Modal, ModalOptions} from '@indice/ng-components';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-report-template-preview-modal',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './report-template-preview-modal.component.html',
  styleUrl: './report-template-preview-modal.component.css'
})
export class ReportTemplatePreviewModal implements OnDestroy {
  @Input() imageUrl: string = '';

  constructor(
    public modalRef: Modal,
    @Inject(ModalOptions) private _options: ModalOptions
  ) {
    console.log('ReportTemplatePreviewModal constructor');
    document.body.classList.add('modal-open');
    document.body.style.maxHeight = '100vh';
  }

  ngOnInit(): void {
    this.imageUrl = this._options?.initialState?.['imageUrl'] as string;
  }

  close = () => {
    this.modalRef.hide()
    document.body.style.maxHeight = 'none';
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
  }
}
